import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { useLocation, useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table,
} from 'reactstrap';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ErrorModal from '../../constants/ErrorModal';
import SpinnerLoader from '../../constants/SpinnerLoader';

const AddPartyPartyCategoryMaster = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState({});
  const [partyCategoryData, setPartyCategoryData] = useState({
    table_flag: 'party_category',
    category_name: '',
    cate_type: '',
    cate_id_if_sub_Selected: null,
    cate_name_if_sub_Selected: '',
    super_cate_id: null,
    balance_sheet_id: null,
    balance_sheet_cate_name: '',
  });
  const [partyCategoryMainTable, setPartyCategoryMainTable] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [editMode, setEditMode] = useState(false);

  const onHandleBackPartyCategory = () => {
    navigate(-1);
  };

  const handleSelect = async (event, value) => {
    console.log(event, value, 'event valeu');

    if (value === null || value === undefined) {
      setPartyCategoryData((prevData) => ({
        ...prevData,
        balance_sheet_id: null,
        balance_sheet_cate_name: '',
      }));

      return;
    }
    let findData = balanceSheetList.find(
      (data) => data.cat_code === value.cat_code,
    );
    await setPartyCategoryData((prevData) => ({
      ...prevData,
      balance_sheet_id: findData.cat_code,
      balance_sheet_cate_name: findData.cat_name,
    }));
  };

  const handleSubSelect = async (event, value) => {
    if (value === null || value === undefined) {
      setPartyCategoryData((prevData) => ({
        ...prevData,
        cate_id_if_sub_Selected: null,
        cate_name_if_sub_Selected: '',
      }));
      return;
    }
    let findData = partyCategoryMainTable.find((data) => data.id === value.id);
    await setPartyCategoryData((prevData) => ({
      ...prevData,
      cate_id_if_sub_Selected: findData.id,
      cate_name_if_sub_Selected: findData.category_name,
    }));
  };

  const onChangeHandle = (e) => {
    const { name, value } = e.target;

    if (name === 'cate_type') {
      if (value === 'SUB') {
        setPartyCategoryData((prevData) => ({
          ...prevData,
          [name]: value,
          // cate_name_if_sub_Selected: partyCategoryData.balance_sheet_cate_name,
          // cate_id_if_sub_Selected: partyCategoryData.balance_sheet_id,

          cate_name_if_sub_Selected: '',
          cate_id_if_sub_Selected: null,
          super_cate_id: partyCategoryData.balance_sheet_id,
        }));
      } else {
        setPartyCategoryData((prevData) => ({
          ...prevData,
          [name]: value,
          cate_name_if_sub_Selected: 'NOT APPLICABLE',
          cate_id_if_sub_Selected: 0,
          super_cate_id: 0,
        }));
      }
    } else {
      setPartyCategoryData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    setErrorMessage((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };

  const validateInputs = () => {
    const errors = {};

    if (!partyCategoryData.party_vendor_id) {
      errors.party_vendor_id = 'Vendor is required';
    }

    if (!partyCategoryData.party_branch_id) {
      errors.party_branch_id = 'Branch is required';
    }

    if (!partyCategoryData.category_name.trim()) {
      errors.category_name = 'Party Category name is required.';
    }
    if (!partyCategoryData.balance_sheet_cate_name) {
      errors.balance_sheet_cate_name =
        'Under Account( Balance Sheet Account) is required.';
    }

    if (!partyCategoryData.cate_type) {
      errors.cate_type = 'Main or Sub is required.';
    }

    if (partyCategoryData.cate_type === 'SUB') {
      if (!partyCategoryData.cate_name_if_sub_Selected) {
        errors.cate_name_if_sub_Selected =
          'If Sub Then Main Account Name is required.';
      }
    }
    return errors;
  };

  const AddPartyCategoryData = async () => {
    if (isSubmitting) {
      // If already submitting, do nothing
      return;
    }

    setIsSubmitting(true);

    const errors = validateInputs();
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setShowErrorModal(true);
      setIsSubmitting(false);

      return;
    } else {
      setErrorMessage({});
    }

    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.post(
        `api/PartyCategoryMaster/create`,
        partyCategoryData,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);

        await getPartyCategory(response.partyCategoryMasterByID.id);
        setEditMode(true);
        // setPartyCategoryData(prevData => ({
        //     ...prevData, // Spread previous state to avoid mutation

        //     category_name: "",
        //     cate_type: "",
        //     cate_id_if_sub_Selected: null,
        //     cate_name_if_sub_Selected: "",
        //     super_cate_id: null,
        //     balance_sheet_id: null,
        //     balance_sheet_cate_name: ""
        // }));
        // navigate("/partyCategory")

        // setPartyCategoryData(response.categoryMasterDetailByID)
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };

  const updatePartyCategoryData = async (id) => {
    if (isSubmitting) {
      // If already submitting, do nothing
      return;
    }

    setIsSubmitting(true);

    const errors = validateInputs();
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setShowErrorModal(true);
      setIsSubmitting(false);

      return;
    } else {
      setErrorMessage({});
    }

    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.put(
        `api/PartyCategoryMaster/update?partyCategoryId=${id}`,
        partyCategoryData,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
        // navigate("/partyCategory")
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };

  const getPartyCategory = async (id) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/PartyCategoryMaster/partycategorybyid?partyCategoryId=${id}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        console.log(response.partyCategoryMasterByID);
        setPartyCategoryData(response.partyCategoryMasterByID);
        // setTotalPage(response.totalPages)
        // toast.success(response.message);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  useEffect(() => {
    if (location.state) {
      console.log(location.state);
      getPartyCategory(location.state.id);
      // setPartyCategoryData(location.state);
      setEditMode(true);
    }
  }, [location.state]);

  // const goTODeleteModel = (id) => {
  //     navigate("/deletePartyCategory", { state: { partyCategoryId: id } })
  // }

  // const goTODeleteModel = (id) => {
  //     navigate("/commonDelete", { state: { itemId: id  , flag : "partyCategory"} })
  //   }

  const goTODeleteModel = (id) => {
    const currentUrl = `${window.location.origin}`;
    const url = `${currentUrl}/commonDelete?itemId=${id}&flag=partyCategory`;
    window.open(url, '_blank');

    setTimeout(() => {
      window.close();
    }, 1000);
  };

  const [balanceSheetList, setBalanceSheetList] = useState([]);
  const [helperMasterSubTable, setHelperMasterSubTable] = useState([]);

  // get the balance sheet data

  const getAllBalanceSheet = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/CommonMaster/allBalanceSheetData`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        // alert(response.message)
        setBalanceSheetList(response.balanceSheetMasterData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  // get helepr master data
  const getHelperMaster = async (formName) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/HelperMaster/allOption?fromName=${formName}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setHelperMasterSubTable(response.helperMasterData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const getPartyCategary = async (category_name) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/PartyCategoryMaster/allpartycategory?pageNo=1&limit=100000000&categoryName=${category_name}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setPartyCategoryMainTable(response.partyCategoryMasterData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  useEffect(() => {
    getAllBalanceSheet();
    getHelperMaster('party_category');
  }, []);

  useEffect(() => {
    let ServiceName = partyCategoryData?.category_name;
    getPartyCategary(ServiceName);
  }, [partyCategoryData?.category_name]);

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [venderMaster, setVenderMasterTable] = useState([]);
  const [branchMaster, setBranchMasterTable] = useState([]);

  const getVendorName = async (page = 1, limit = 10, search = '') => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        // console.log(response.CompanyMasterMasterData)
        if (
          response.venderMasterData.length === 1 &&
          response.venderMasterData
        ) {
          setVenderMasterTable(response.venderMasterData);
          setPartyCategoryData((prevDetails) => ({
            ...prevDetails,
            party_vendor_id: response.venderMasterData[0].id,
          }));
        }
        //  else if (response.venderMasterData.length === 0) {
        //     setVenderMasterTable(response.venderMasterData)
        //     setPartyCategoryData((prevDetails) => ({
        //         ...prevDetails,
        //         party_vendor_id: null
        //     }));

        //     setErrorMessage((prevDetails) => ({
        //         ...prevDetails,
        //         party_vendor_id: 'Vender is required'
        //     }));

        //     setShowErrorModal(true)
        // }
        else {
          setVenderMasterTable(response.venderMasterData);
        }
        // toast.success(response.message);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading((prev) => ({ ...prev, vender: false }));
    }
  };

  const getBranchData = async (page = 1, limit = 10, search = '') => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const filterName = partyCategoryData.party_vendor_id
        ? partyCategoryData.party_vendor_id
        : null;

      let queryString = `pageNo=${page}&limit=100000&searchKey=${search}`;
      if (filterName) {
        queryString += `&filterName=${filterName}`;
      }

      const response = await apiService.get(
        `api/BranchMaster/all?${queryString}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        // console.log(response.BranchMasterMasterData)
        // setBranchMasterTable(response.branchMasterData)

        if (
          response.branchMasterData.length === 1 &&
          response.branchMasterData
        ) {
          setBranchMasterTable(response.branchMasterData);
          setPartyCategoryData((prevDetails) => ({
            ...prevDetails,
            party_branch_id: response.branchMasterData[0].id,
          }));
        } else if (response.branchMasterData.length === 0) {
          setBranchMasterTable(response.branchMasterData);

          setPartyCategoryData((prevDetails) => ({
            ...prevDetails,
            party_branch_id: null,
          }));

          setErrorMessage((prevDetails) => ({
            ...prevDetails,
            party_branch_id: 'Branch is required',
          }));

          setShowErrorModal(true);
        } else {
          setBranchMasterTable(response.branchMasterData);
          setPartyCategoryData((prevDetails) => ({
            ...prevDetails,
            party_branch_id: null,
          }));
        }

        // toast.success(response.message);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading((prev) => ({ ...prev, branch: false }));
    }
  };

  useEffect(() => {
    getVendorName();
    getBranchData();
  }, [partyCategoryData?.party_vendor_id]);

  const [pageloading, setPageLoading] = useState({
    vender: true,
    branch: true,
  });

  useEffect(() => {
    const allApisLoaded = Object.values(pageloading).every(
      (status) => status === false,
    );

    if (!allApisLoaded) return;

    const newErrors = {};

    if (!venderMaster || venderMaster.length === 0) {
      newErrors.vender_master_id = 'Vender is required.';
    }

    if (!branchMaster || branchMaster.length === 0) {
      newErrors.branch_master_id = 'Branch is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrorMessage(newErrors);
      setShowErrorModal(true);
    } else {
      setErrorMessage({});
      setShowErrorModal(false);
    }
  }, [branchMaster, venderMaster, pageloading]);

  if (Object.values(pageloading).some((status) => status === true)) {
    return <SpinnerLoader />;
  }

  return (
    <>
      <Row>
        <Col>
          <Card className='card-box height-100-p pd-20 mb-20'>
            <CardTitle
              tag='h6'
              className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
            >
              <div className='d-flex align-items-center'>
                <i className='bi bi-bell mr-2'></i>

                {editMode
                  ? 'Edit Party Category Master'
                  : 'Party Category Master'}
              </div>

              <div>
                {editMode && (
                  <Button
                    color='danger'
                    size='bg'
                    className='ms-auto'
                    onClick={() => goTODeleteModel(partyCategoryData.id)}
                  >
                    Delete
                  </Button>
                )}

                <Button
                  color='warning'
                  size='bg'
                  onClick={onHandleBackPartyCategory}
                  className='ms-2'
                >
                  Back
                </Button>
              </div>
            </CardTitle>

            <CardBody>
              <Form>
                <Row>
                  <Col xl={12}>
                    {(venderMaster.length === 0 || venderMaster.length > 1) && (
                      <FormGroup>
                        <Label for='party_vendor_id'>Vendor Name</Label>
                        <Input
                          className='custom-border'
                          type='select'
                          id='party_vendor_id'
                          name='party_vendor_id'
                          value={partyCategoryData.party_vendor_id}
                          onChange={onChangeHandle}
                        >
                          <option value=''>Select</option>
                          {venderMaster.map((option) => (
                            <option
                              key={option.id}
                              value={option.id}
                              data-id={option.id}
                            >
                              {option.vender_name}
                            </option>
                          ))}
                        </Input>
                        {errorMessage.party_vendor_id && (
                          <FormText color='danger'>
                            {errorMessage.party_vendor_id}
                          </FormText>
                        )}
                      </FormGroup>
                    )}
                  </Col>

                  <Col xl={12}>
                    {(branchMaster.length === 0 || branchMaster.length > 1) && (
                      <FormGroup>
                        <Label for='party_branch_id'>Branch Name</Label>
                        <Input
                          className='custom-border'
                          type='select'
                          id='party_branch_id'
                          name='party_branch_id'
                          value={partyCategoryData.party_branch_id}
                          onChange={onChangeHandle}
                        >
                          <option value=''>Select</option>
                          {branchMaster.map((option) => (
                            <option
                              key={option.id}
                              value={option.id}
                              data-id={option.id}
                            >
                              {option.branch_name}
                            </option>
                          ))}
                        </Input>
                        {errorMessage.party_branch_id && (
                          <FormText color='danger'>
                            {errorMessage.party_branch_id}
                          </FormText>
                        )}
                      </FormGroup>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col xl={12}>
                    <FormGroup>
                      <Label for='category_name'>Party Category Name</Label>
                      <Input
                        className='custom-border'
                        id='category_name'
                        name='category_name'
                        onChange={(e) => {
                          onChangeHandle(e);
                        }}
                        value={partyCategoryData?.category_name}
                        // placeholder="Enter a Party Category"
                        type='text'
                      />
                      {errorMessage.category_name && (
                        <FormText color='danger'>
                          {errorMessage.category_name}
                        </FormText>
                      )}
                      {/* {errorMessage.category_name && <p style={{ color: 'red' }}>{errorMessage.category_name}</p>} */}
                    </FormGroup>
                  </Col>

                  <Col xl={12}>
                    <FormGroup>
                      <Label for='balance_sheet_cate_name'>
                        Under Account( Balance Sheet Account)
                      </Label>
                      <Autocomplete
                        className='custom-border'
                        size='small'
                        // sx={{ width: 300 }}
                        autoHighlight
                        id='balance_sheet_cate_name'
                        name='balance_sheet_cate_name'
                        options={balanceSheetList}
                        getOptionLabel={(option) => option.cat_name || ''}
                        renderInput={(params) => (
                          <TextField {...params} label='Select' />
                        )}
                        renderOption={(props, option, state) => (
                          <li {...props} key={state.index}>
                            {option.cat_name}
                          </li>
                        )}
                        renderGroup={(params) => params}
                        value={
                          balanceSheetList.find(
                            (option) =>
                              option.cat_name ===
                              partyCategoryData.balance_sheet_cate_name,
                          ) || null
                        }
                        onChange={handleSelect}
                        readOnly={!partyCategoryData?.category_name}
                      />

                      {/* {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} */}
                      {errorMessage.balance_sheet_cate_name && (
                        <FormText color='danger'>
                          {errorMessage.balance_sheet_cate_name}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col xl={12}>
                    <FormGroup>
                      <Label for='cate_type'>Main or Sub </Label>
                      <Input
                        className='custom-border'
                        id='cate_type'
                        name='cate_type'
                        onChange={(e) => {
                          onChangeHandle(e);
                        }}
                        value={partyCategoryData?.cate_type}
                        // placeholder="Enter a Party Category"
                        type='select'
                        disabled={!partyCategoryData.balance_sheet_cate_name}
                      >
                        <option value=''>Select</option>
                        {helperMasterSubTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_data}
                          </option>
                        ))}
                      </Input>
                      {errorMessage.cate_type && (
                        <FormText color='danger'>
                          {errorMessage.cate_type}
                        </FormText>
                      )}
                      {/* {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} */}
                    </FormGroup>
                  </Col>

                  <Col xl={12}>
                    <FormGroup>
                      <Label for='cate_name_if_sub_Selected'>
                        If Sub Then Main Account Name{' '}
                      </Label>
                      {partyCategoryData.cate_type === 'MAIN' ? (
                        <Input
                          className='custom-border'
                          id='cate_name_if_sub_Selected'
                          name='cate_name_if_sub_Selected'
                          // onChange={(e) => { onChangeHandle(e) }}
                          value={partyCategoryData?.cate_name_if_sub_Selected}
                          // placeholder="Enter a Party Category"
                          type='text'
                          disabled
                        />
                      ) : (
                        <Autocomplete
                          className='custom-border'
                          size='small'
                          // sx={{ width: 300 }}
                          autoHighlight
                          id='cate_name_if_sub_Selected'
                          name='cate_name_if_sub_Selected'
                          options={partyCategoryMainTable}
                          getOptionLabel={(option) =>
                            option.category_name || ''
                          }
                          renderInput={(params) => (
                            <TextField {...params} label='Select' />
                          )}
                          renderOption={(props, option, state) => (
                            <li {...props} key={state.index}>
                              {option.category_name}
                            </li>
                          )}
                          renderGroup={(params) => params}
                          value={
                            partyCategoryMainTable.find(
                              (option) =>
                                option.category_name ===
                                partyCategoryData.cate_name_if_sub_Selected,
                            ) || null
                          }
                          onChange={handleSubSelect}
                          readOnly={!partyCategoryData?.cate_type}
                        />
                      )}
                      {/* {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} */}
                      {errorMessage.cate_name_if_sub_Selected && (
                        <FormText color='danger'>
                          {errorMessage.cate_name_if_sub_Selected}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>
                </Row>

                {editMode ? (
                  <Button
                    type='button'
                    className='mt-2'
                    color='primary'
                    disabled={isSubmitting}
                    onClick={() =>
                      updatePartyCategoryData(partyCategoryData.id)
                    }
                  >
                    Update
                  </Button>
                ) : (
                  <Button
                    type='button'
                    className='mt-2'
                    color='primary'
                    disabled={isSubmitting}
                    onClick={() => AddPartyCategoryData()}
                  >
                    Save
                  </Button>
                )}

                {/* <Button type="button" className="mt-2" color="primary" onClick={() => AddPartyCategoryData()}>Save</Button> */}
              </Form>
            </CardBody>

            {/* Error Model */}

            <ErrorModal
              show={showErrorModal}
              title='Validation / Action Required'
              content={errorMessage}
              condition={true}
              onCancel={() => setShowErrorModal(false)}
              // onConfirm={true}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AddPartyPartyCategoryMaster;
